export default __webpack_public_path__ + "static/media/RR310_LateralIzq.a9c421a4.webp";